<template>
  <span class="search-result-length" :class="className">
    {{ isNaN(resultLength) ? '...' : resultLength }}
  </span>
</template>

<script>
import { API_STATES } from '@components/organisms/teaser-api/bpb-api-endpoint.vue';

export default {
  inject: {
    context: {
      default() {
        return {};
      },
    },
  },

  computed: {
    isFetching() {
      return this.context.state === API_STATES.fetching;
    },

    className() {
      return this.isFetching ? 'search-result-length--is-fetching' : '';
    },
    resultLength() {
      return this.context?.lastResponse?.length || 0;
    },
  },
};
</script>
